export const recordsConstants = {
    FETCH_RECORDS: 'FETCH_RECORDS',
    FETCH_RECORD: 'FETCH_RECORD',
    FETCH_RECORD_DOWNLOAD: 'FETCH_RECORD_DOWNLOAD',
    PLAY_RECORD: 'PLAY_RECORD',
    PAUSE: 'PAUSE',
    RESUME: 'RESUME',
    STOP: 'STOP',
    SET_RECORD_POS: 'SET_RECORD_POS',
    DATA_DECODE_ERROR: 'DATA_DECODE_ERROR',
    SET_PLAYBACK_RATE: 'SET_PLAYBACK_RATE',
};
